import React from 'react';
import classNames from 'classnames';
import addTestId from '../../utils/addTestId';
import styles from './AnnotationLinkInput.module.scss';
import SVGIcon from '../../components/SVGIcon';
import linkIcon from '../../icons/link.svg';

interface AnnotationLinkInputProps {
  value: string;
  onChange(value: string): void;
  onSave(): void;
}

const AnnotationLinkInput = ({
  value,
  onChange,
  onSave,
}: AnnotationLinkInputProps) => {
  return (
    <form
      {...addTestId('annotation-link-input-form')}
      onSubmit={(e) => {
        e.preventDefault();
        onSave();
      }}
      className={styles.container}
    >
      <SVGIcon
        className={classNames(styles.icon, {
          [styles.active]: value.trim() !== '',
        })}
        size={16}
      >
        {linkIcon}
      </SVGIcon>
      <input
        autoFocus
        className={styles.input}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Paste a reference link"
        aria-label="Reference link"
      />
    </form>
  );
};

export default AnnotationLinkInput;
